import type { SVGProps } from "react";

export function PicaminiLogoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient id="pkm-tool-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4F46E5" />
          <stop offset="0.5" stopColor="#7C3AED" />
          <stop offset="1" stopColor="#2563EB" />
        </linearGradient>
        <linearGradient id="pkm-spark-grad" x1="12" y1="12" x2="28" y2="28" gradientUnits="userSpaceOnUse">
          <stop stopColor="#F59E0B" />
          <stop offset="1" stopColor="#F43F5E" />
        </linearGradient>
      </defs>
      {/* Outer rounded container */}
      <rect width="40" height="40" rx="11" fill="url(#pkm-tool-grad)" />
      
      {/* Tool / Selector Grid Elements */}
      {/* Top-left tool square (Selection Picker) */}
      <rect x="9" y="9" width="9" height="9" rx="3" fill="white" fillOpacity="0.95" />
      <path d="M12 13.5L14 15.5L17.5 12" stroke="#4F46E5" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />

      {/* Top-right tool square (Sparkle / Generator) */}
      <rect x="22" y="9" width="9" height="9" rx="3" fill="white" fillOpacity="0.95" />
      <path d="M26.5 11.5L27.2 13.2L28.9 13.9L27.2 14.6L26.5 16.3L25.8 14.6L24.1 13.9L25.8 13.2Z" fill="url(#pkm-spark-grad)" />

      {/* Bottom-left tool square (Timer / Clock) */}
      <rect x="9" y="22" width="9" height="9" rx="3" fill="white" fillOpacity="0.95" />
      <circle cx="13.5" cy="26.5" r="2.8" stroke="#7C3AED" strokeWidth="1.4" fill="none" />
      <path d="M13.5 25V26.5H15" stroke="#7C3AED" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />

      {/* Bottom-right tool square (Team / Group Users) */}
      <rect x="22" y="22" width="9" height="9" rx="3" fill="white" fillOpacity="0.95" />
      <circle cx="26.5" cy="24.8" r="1.4" fill="#2563EB" />
      <path d="M24 28C24 26.7 25.1 26.2 26.5 26.2C27.9 26.2 29 26.7 29 28" stroke="#2563EB" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

export function PicaminiLogo({ className = "h-8" }: { className?: string }) {
  return (
    <div className={`inline-flex items-center gap-2.5 font-display font-extrabold tracking-tight ${className}`}>
      <PicaminiLogoIcon className="size-8 sm:size-9 shrink-0 shadow-sm" />
      <div className="flex items-baseline gap-1">
        <span className="text-xl sm:text-2xl font-black bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 dark:from-indigo-400 dark:via-purple-400 dark:to-blue-400 bg-clip-text text-transparent">
          Picamini.online
        </span>
      </div>
    </div>
  );
}
